import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
/** Normalized YYYY-MM-DD list (restaurant timezone dates). */
export function normalizeBookingPausedDates(dates) {
    if (!Array.isArray(dates))
        return [];
    const out = dates.filter((d) => typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d.trim()));
    return [...new Set(out.map((d) => d.trim()))].sort();
}
export function isBookingDatePaused(dateStr, paused) {
    if (!dateStr || !paused?.length)
        return false;
    return paused.includes(dateStr);
}
export function bookingTimestampToDateStr(timestamp, tz) {
    return moment.tz(timestamp, tz).format(FORMATS.moment.date);
}
//# sourceMappingURL=booking_paused_dates.js.map